<template>
  <div class="filter-modes">
    <div class="filter-status btnHover">
      <el-dropdown trigger="click" @command="handleCommand_of" ref="drop">
        <span class="el-dropdown-link">
          <i class="icon iconfont iconicon_task_list"></i>
          {{labelValue}}
        </span>
        <el-dropdown-menu slot="dropdown" class="filter-status-dropdown filter-status-dropdown--modes">
          <el-cascader-panel :options="options" v-model="defaultValue" @change="onChange">
          </el-cascader-panel>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
export default {
  data() {
    return {
      options: [{
        value: 0,
        label: '按任务清单查看',
        children: []
      }, {
        value: 1,
        label: '按执行人查看',
        children: [{
          label: '按任务数排序',
          value: 'quantity'
        }, {
          label: '按姓名A-Z排序',
          value: 'name'
        }]
      }],
    }
  },
  computed: {
    ...mapState('task/task',{
      ganttType: state => state.ganttType,
      sort_method: state => state.queryMsg.sort_method,
      taskList: state => state.taskList,
      task_list_id: state => state.queryMsg.task_list_id
    }),
    defaultValue: {
      get() {
        if(Number(this.ganttType) === 0) {
          return [this.ganttType, this.task_list_id]
        } else {
          return [this.ganttType, this.sort_method]
        }
      },
      set(newValue) {
        this.handleCommand_of(newValue[0])
        if(Number(newValue[0]) === 0) {
          this.setTaskList(newValue[1])
        } else {
          this.handleCommand(newValue[1])
        }
      }
    },
    labelValue() {
      return (this.options.find(res => res.value == this.ganttType)).label
    }
  },
  watch: {
    taskList: {
      handler() {
        if(this.taskList) {
          this.options[0].children = this.taskList.map(res => {
            return {
              label: res.title,
              value: res.task_list_id
            }
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations('task/task', ['set_ganttType','set_task_methods', 'set_taskList']),
    handleCommand(value) {
      this.set_task_methods(value)
    },
    handleCommand_of(index) {
      this.set_ganttType(index)
    },
    setTaskList(id) {
      this.set_taskList(id)
    },
    onChange(val) {
      console.log('---------asd-------', val)
      this.$refs.drop.hide()
    }
  }
}
</script>
<style lang="scss">
.filter-modes {
  display: flex;
  align-items: center;
}
</style>
